import { useContext, useEffect, useRef } from 'react';
import { LocalAuthContext } from '~/components/Auth';
import createCustomFetch from '~/components/Tools/createCustomFetch';

declare global {
  interface Window {
    disableSnowplowTracking?: boolean;
    disableMixpanelTracking?: boolean;
  }
}

const useCompanySettingConfig = ({ enableDatadog }: { enableDatadog: boolean }) => {
  const auth = useContext(LocalAuthContext);
  const isCustomFetchInitialized = useRef(false);

  const isDatadogDisabledForCompany = auth?.featureToggles?.isDatadogDisabled;
  const disableDatadog = !enableDatadog || isDatadogDisabledForCompany;
  const customFetchEnabled = auth?.featureToggles?.customFetchEnabled;
  const disableSnowplowTracking = auth?.featureToggles?.disableSnowplowTracking;
  const disableMixpanelTracking = auth?.featureToggles?.disableMixpanelTracking;

  useEffect(() => {
    if (customFetchEnabled && !isCustomFetchInitialized.current) {
      createCustomFetch(auth?.featureToggles?.customFetchReqOverrideEnabled);
      isCustomFetchInitialized.current = true;
    }
  }, [customFetchEnabled]);

  useEffect(() => {
    if (disableSnowplowTracking === true) {
      window.disableSnowplowTracking = true;
    }

    if (disableMixpanelTracking === true) {
      window.disableMixpanelTracking = true;
    }
  }, [disableSnowplowTracking, disableMixpanelTracking]);

  return {
    auth,
    disableDatadog,
  };
};

export default useCompanySettingConfig;
